// Copyright (c) 2022, Comsearch, Inc., All rights reserved

const lego_authentication_broadcast_channel = new BroadcastChannel('lego_authentication_broadcast_channel')

export default lego_authentication_broadcast_channel
